import { render, staticRenderFns } from "./GenerarContrasena.vue?vue&type=template&id=52c0490e&"
import script from "./GenerarContrasena.vue?vue&type=script&lang=js&"
export * from "./GenerarContrasena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports